import { render } from "./HomepageFaq.vue?vue&type=template&id=19a9f272&scoped=true"
import script from "./HomepageFaq.vue?vue&type=script&lang=js"
export * from "./HomepageFaq.vue?vue&type=script&lang=js"

import "./HomepageFaq.vue?vue&type=style&index=0&id=19a9f272&scoped=true&lang=css"

import exportComponent from "/home/forge/preflight.unbundledlegalhelp.dev.farm/releases/000000/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a9f272"]])

export default __exports__